import { IResourceComponentsProps, useList, usePermissions } from "@pankod/refine-core";
import { Card, Select, Form, Row, Col, Button } from "@pankod/refine-antd";
import { WorkPlanProgressStats } from "components/organisms/work-plan-progress-stats";
import { IWorkPlan } from "interfaces/work-plan.interface";
import { useState } from "react";
import { ClearOutlined } from "@ant-design/icons";

export const WorkPlanSummary: React.FC<IResourceComponentsProps> = () => {
    const { data: permissionsData } = usePermissions();
    const isAdmin = permissionsData?.includes('work-plans:admin');
    
    const [selectedPosition, setSelectedPosition] = useState<number | undefined>(undefined);

    // Obtener las posiciones para el filtro
    const { data: positionsData } = useList({
        resource: "work-plans/positions",
        config: {
            hasPagination: false,
        },
    });

    const positions = positionsData?.data || [];
    
    // Obtener todos los work plans
    const { data: allWorkPlansData } = useList<IWorkPlan>({
        resource: "work-plans",
        config: {
            hasPagination: false,
            filters: selectedPosition ? [
                {
                    field: "work_plan_position_id",
                    operator: "eq",
                    value: selectedPosition,
                }
            ] : [],
        },
    });

    return (
        <div style={{ padding: '0px' }}>
            <Card 
                style={{ marginBottom: 16 }}
                size="small"
            >
                {isAdmin && (
                    <Form layout="vertical">
                        <Row gutter={16} align="bottom">
                            <Col span={8}>
                                <Form.Item label="Filtrar por Unidad Organizacional">
                                    <Select
                                        placeholder="Todas las unidades organizacionales"
                                        allowClear
                                        showSearch
                                        filterOption={(input, option) =>
                                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                        }
                                        value={selectedPosition}
                                        onChange={(value) => setSelectedPosition(value || undefined)}
                                        options={positions.map((position: any) => ({
                                            label: position.name,
                                            value: position.id,
                                        }))}
                                    />
                                </Form.Item>
                            </Col>
                            {selectedPosition && (
                                <Col>
                                    <Form.Item>
                                        <Button 
                                            icon={<ClearOutlined />}
                                            onClick={() => setSelectedPosition(undefined)}
                                        >
                                            Mostrar todas
                                        </Button>
                                    </Form.Item>
                                </Col>
                            )}
                        </Row>
                    </Form>
                )}
            </Card>

            <WorkPlanProgressStats 
                workPlans={allWorkPlansData?.data || []}
                filterByPosition={selectedPosition}
            />
        </div>
    );
};

export default WorkPlanSummary;
